var edit = function (cta) {
  var cta_path =
    window.location.origin + "/websites/" + cta.website_id + "/cta/" + cta.id;
  $('[data-toggle="tooltip"]').tooltip();



  $(".create-variant").on("click", function () {
    $("#new-variant").modal("show");
  });

  $("#name-edit").on("submit", function (e) {
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: cta_path + "/update",
      data: {
        cta: {
          name: $("#name-edit-field").val(),
        },
      },
    });

    return false;
  });

  $("#name-edit input").on("change", function () {
    $("#name-edit").submit();
  });

  $("#testing-type").on("submit", function (e) {
    e.preventDefault();
    var variants = {};

    $(".percentage").each(function (index, input) {
      var variant_id = $(input).attr("data-id");
      var percentage = $(input).val();
      variants[variant_id] = percentage;
    });

    $.ajax({
      type: "POST",
      url: cta_path + "/update",
      data: {
        cta: {
          test_type: $("#split-testing-type").val(),
        },
      },
    });
  });

  $("#split-testing-type").on("change", function () {
    $("#testing-type").submit();
  });

  $("#reset").on("click", function (e) {
    e.preventDefault();

    if (
      confirm(
        "Are you sure you want to reset this CTA's analytics? All of your CTA and variant stats will be set to 0"
      )
    ) {
      window.location = $(this).attr("href");
    }
  });

  $("#page-url").on("submit", function (e) {
    e.preventDefault();
    $.ajax({
      type: "PUT",
      url: cta_path,
      data: $("#page-url").serialize(),
      dataType: "JSONP",
      complete: function (data) {
        $("#path-save").hide();
        if (data !== undefined && data.responseText) {
          var data = $.parseJSON(data.responseText);
          if (data !== undefined && data.message == "Page path already taken") {
            $("#page-path-taken").show();
            if (data.cta_in_use) {
              $("#page-path-taken p").html(
                "This page path has already been taken by " +
                  '<a style="color: inherit !important; text-decoration: underline !important;" href="' +
                  window.location.origin +
                  "/websites/" +
                  data.cta_in_use.website_id +
                  "/cta/" +
                  data.cta_in_use.id +
                  '/launch" target="_blank">' +
                  (data.cta_in_use.name
                    ? data.cta_in_use.name
                    : "CTA " + data.cta_in_use.id) +
                  " →</a>"
              );
            }
          }
        }
      },
    });

    return false;
  });
  
  function updatePreviewLink() {
    const pageUrlSelect = $('#page-url select[name="cta[domain_id]"]');
    // Skip when placeholder (e.g. "Select your domain") is selected
    if ($(pageUrlSelect).find("option:selected").is(":disabled")) {
      return;
    }
    const selectedDomain = $(pageUrlSelect).find("option:selected").text().trim();
    const protocol = selectedDomain.indexOf('lvh.me') !== -1 ? 'http://' : 'https://';
    var link =
        protocol +
        selectedDomain +
        "/" +
        $('#page-url input[name="cta[page_path]"]').val();

    $(".preview-link").each(function (i, preview_link) {
      var broadcast_id = $(preview_link).attr("data-broadcast-id");
      var website_id = $(preview_link).attr("data-website-id");

      if (broadcast_id) {
        link = link + "/?broadcast_id=" + broadcast_id;
      }

      $(preview_link).text(link);
      $(preview_link).attr("href", `${link}${link.indexOf("?") == -1 ? "?" : "&"}cf_${website_id}_logged_in=true`);
    });
  }
  updatePreviewLink();
  

  const pageUrlInput = document.getElementById("page-url");

  if (pageUrlInput) {
    const externalIntegrationType = pageUrlInput.getAttribute(
      "data-external_integration_type"
    );
    const pageUrlSelect = $('#page-url select[name="cta[domain_id]"]');
    const startValue = $(pageUrlSelect).val();

    $(pageUrlSelect).on("change", function (event) {
      updatePreviewLink();

      $("#page-path-taken").hide();
      $("#path-save").show();
    });

    $("#page-url").on("submit", function (event) {
      event.preventDefault();
      const value = $(pageUrlSelect).val();

      if (
        !externalIntegrationType ||
        (value !== externalIntegrationType &&
          confirm(
            `Are you sure you want to unsync and remove this page from ${externalIntegrationType}?`
          ))
      ) {
        if (value == "Shopify") {
          $(
            ".cta-page-settings[data-group='open-graph'], .cta-page-settings[data-group='index']"
          ).hide();
          $(".cta-page-settings[data-group='shopify']").show();
        } else {
          $(
            ".cta-page-settings[data-group='open-graph'], .cta-page-settings[data-group='index']"
          ).show();
          $(".cta-page-settings[data-group='shopify']").hide();
        }
        return true;
      } else {
        $(pageUrlSelect).val(startValue);
      }
    });

    $('#page-url input[name="cta[page_path]"]').on("keyup", function () {
      $(this).val(function (_, v) {
        return v.replace(/[^a-zA-Z0-9-]/, "").toLowerCase();
      });

      updatePreviewLink();

      $("#page-path-taken").hide();
      $("#path-save").show();
    });

    $(".preview-link").on("click", function (e) {
      e.preventDefault();

      const url = $(this).text().trim();
      const websiteId = $(this).attr("data-website-id");
      window.open(`${url}${url.indexOf("?") == -1 ? "?" : "&"}cf_${websiteId}_logged_in=true`, "_blank");
    });
  }

  $("#seo_index").on("click", function () {
    $("#cta_seo_index").click();
  });

  $("#shopify_header_switch").click(function () {
    $("#shopify_header").click();
  });

  $("#shopify_header").on("change", function () {
    if ($(this).is(":checked")) {
      $("[name='cta[options][shopify-header]']").val("true");
    } else {
      $("[name='cta[options][shopify-header]']").val("false");
    }
  });

  $("#shopify_footer_switch").click(function () {
    $("#shopify_footer").click();
  });

  $("#shopify_footer").on("change", function () {
    if ($(this).is(":checked")) {
      $("[name='cta[options][shopify-footer]']").val("true");
    } else {
      $("[name='cta[options][shopify-footer]']").val("false");
    }
  });

  $("#changeCTAType form").on("submit", function (e) {
    e.preventDefault();

    if (
      confirm(
        "Are you sure you want to change this CTA's type? This will effect how it displays on your website"
      )
    ) {
      $(this)
        .find('input[type="submit"]')
        .attr("value", "Processing...")
        .addClass("disabled");

      setTimeout(function () {
        location.reload();
      }, 3000);

      return true;
    }
  });

  // Test live functionality
  function updateTestUrl() {
    var raw = $('#testLiveUrlInput').val();
    var testUrlDisplay = $('#testUrlDisplay');
    var goToUrlBtn = $('#goToUrlBtn');
    var qrCodeContainer = $('#qrCode');
    var forceCampaign = $('#forceCampaignCheckbox').is(':checked');
    
    if (!raw) {
      testUrlDisplay.text('Enter a URL above to generate test link');
      goToUrlBtn.prop('disabled', true);
      return;
    }
    
    raw = raw.trim();
    var candidate = raw;
    if (!/^https?:\/\//i.test(candidate)) {
      candidate = window.location.protocol + '//' + candidate;
    }
    
    try {
      var url = new URL(candidate);
      // Add logged-in parameter first
      url.searchParams.set('cf_' + cta.website_id + '_logged_in', 'true');
      // Add admin parameter
      url.searchParams.set('cf_' + cta.website_id + '_admin', 'true');
      // Then add test campaign parameter only if checkbox is checked
      if (forceCampaign) {
        url.searchParams.set('cf_campaign_id', cta.id);
      }
      
      var finalUrl = url.toString();
      testUrlDisplay.text(finalUrl);
      goToUrlBtn.prop('disabled', false);
      
      // Generate QR code
      if (window.QRCode) {
        qrCodeContainer.empty();
        
        // Create a canvas element first
        var canvas = document.createElement('canvas');
        qrCodeContainer.append(canvas);
        
        window.QRCode.toCanvas(canvas, finalUrl, {
          width: 128,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          },
          errorCorrectionLevel: 'M'
        }, function (err) {
          if (err) {
            console.error('QR Code generation failed:', err);
          } else {
            // Add styling to the canvas
            $(canvas).css({
              'border-radius': '4px',
              'box-shadow': '0 1px 3px rgba(0,0,0,0.1)'
            });
          }
        });
      }
    } catch (err) {
      testUrlDisplay.text('Please enter a valid URL');
      goToUrlBtn.prop('disabled', true);
    }
  }

  $('#testLiveUrlInput').on('input', updateTestUrl);
  $('#forceCampaignCheckbox').on('change', updateTestUrl);
  
  // Handle toggle clicks for the force campaign checkbox
  $('.campaign-toggle').on('click', function() {
    var checkbox = $(this).siblings('#forceCampaignCheckbox');
    checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
  });

  // Copy URL functionality

  $('#testUrlDisplay').on('click', function() {
    var url = $(this).text();
    if (url && url !== 'Enter a URL above to generate test link' && url !== 'Please enter a valid URL') {
      navigator.clipboard.writeText(url).then(function() {
        // Show Bootstrap tooltip
        var $display = $('#testUrlDisplay');
        $display.attr('data-original-title', 'Copied!');
        $display.tooltip('show');
        
        // Hide tooltip after 1 second
        setTimeout(function() {
          $display.tooltip('hide');
          $display.attr('data-original-title', 'Click to copy');
        }, 1000);
      });
    }
  });

  // Form submit handler for "Go To URL" button
  $('#testLiveForm').on('submit', function(e) {
    e.preventDefault();
    var testUrl = $('#testUrlDisplay').text();
    if (testUrl && testUrl !== 'Enter a URL above to generate test link' && testUrl !== 'Please enter a valid URL') {
      window.open(testUrl, '_blank', 'noopener');
    }
  });

  // Trigger URL generation when modal opens (for default value)
  $('#testLiveModal').on('shown.bs.modal', function() {
    // Initialize QRCode library if not already available
    if (!window.QRCode) {
      import('qrcode').then(function(QRCode) {
        window.QRCode = QRCode.default;
        // Generate QR code after library is loaded
        if ($('#testLiveUrlInput').val()) {
          updateTestUrl();
        }
      }).catch(function(err) {
        console.error('Failed to load QRCode library:', err);
      });
    }
    
    $('#testLiveUrlInput').trigger('input');
    // Initialize tooltip for URL display
    $('#testUrlDisplay').tooltip({
      placement: 'top',
      trigger: 'manual'
    });
    $('#forceCampaignCheckbox').trigger('click');
    
    // Ensure QR code is generated after a short delay if library is already available
    setTimeout(function() {
      if ($('#testLiveUrlInput').val() && window.QRCode) {
        updateTestUrl();
      }
    }, 500);
  });
};

export default edit;
